// https://vuex.vuejs.org/en/actions.html

import JwtService from "@/utils/jwt.service";
import NewApiService from "@/utils/new.api.service";
import Axios from "axios";
import { NEW_API_URL } from "../../../common/config-local";

export default {
  async login(context, credentials) {
    return new Promise((resolve, reject) => {
      context.commit("set_loading", true);
      context.commit("clearMessage", true);
      Axios.defaults.withCredentials=true
      Axios.get(NEW_API_URL +'sanctum/csrf-cookie').then(() => {
        Axios.post(NEW_API_URL + "auth/login", credentials, { withCredentials: true })
          .then(({data}) => {
            console.log(data)
            context.commit("set_auth", data.token);
            resolve(data.token);
          })
          .catch(({ response }) => {
            reject(response.data)
          })
          .finally(() => {
            context.commit("set_loading", false);
          });
      })
    });
  },
  // Révoque le jeton côté serveur avant d'effacer le cookie : il restait
  // valide après la déconnexion. Une erreur (jeton déjà expiré) n'empêche
  // pas la déconnexion locale.
  logout(context) {
    NewApiService.setHeader();
    return NewApiService.post("auth/logout")
      .catch(() => {})
      .then(() => context.commit("purge_auth"));
  },
  async check_auth(context) {
    if (JwtService.getToken()) {
      NewApiService.setHeader();
      await NewApiService.get("auth/user").then(({ data }) => {
        const ability = context.getters.ability;
        context.commit("set_user", data.user);

        ability.update([{ actions: "read", subject: "all" }]);
        ability.update(data.user.rules);
      }).catch(() => {
        context.commit("purge_auth");
      });
    } else {
      context.commit("purge_auth");
    }
  },
  update_user(context, payload) {
    const { email, username, password, image, bio } = payload;
    const user = {
      email,
      username,
      bio,
      image
    };
    if (password) {
      user.password = password;
    }

    return NewApiService.put("user", { user: user }).then(({ data }) => {
      context.commit("set_auth", data.user);
      return data;
    });
  },
  activate(context, params) {
    const { username, password, hash } = params;
    if (username && password && hash) {
      return new Promise(resolve => {
        NewApiService.post("user/activate", { user: { username, hash, password } })
          .then(({ data }) => {
            context.commit("set_auth", data.user);
            resolve(data);
          })
          .catch(({ response }) => {
            context.commit("set_error", response.data.errors);
          });
      });
    }
  },
  forgotPassword(context, params) {
    return new Promise((resolve, reject) => {
      NewApiService.get('auth/forgot-password', params)
        .then((data) => {
          resolve(data)
        })
        .catch(({data}) => {
          reject(data)
        })
    })
  },
  resetPassword(context, params) {
    return new Promise((resolve, reject) => {
      NewApiService.post('auth/reset-password', params)
        .then((data) => {
          resolve(data)
        })
        .catch(({data}) => {
          reject(data)
        })
    })
  }
};
